<template>
  <control-item title="Actions">
    <div class="stream-controls-actions__buttons">
      <button
        class="stream-controls-actions__button"
        :disabled="!historyUndoAvailable || loading"
        @click="undoHistory"
        title="Undo"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.0002 12L10.4102 10.59L7.8302 8L12.1652 8L12.1652 6L7.8302 6L10.4102 3.41L9.0002 2L4.00021 7L9.0002 12Z" fill="white"></path><path d="M12.0002 20C15.3139 20 18.0002 17.3137 18.0002 14C18.0002 10.6863 15.3139 8 12.0002 8V6C16.4185 6 20.0002 9.58172 20.0002 14C20.0002 18.4183 16.4185 22 12.0002 22V20Z" fill="white"></path></svg>
      </button>
      <button
        class="stream-controls-actions__button stream-controls-actions__button--arrow-back"
        :disabled="!historyRedoAvailable || loading"
        @click="redoHistory"
        title="Redo"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.0002 12L10.4102 10.59L7.8302 8L12.1652 8L12.1652 6L7.8302 6L10.4102 3.41L9.0002 2L4.00021 7L9.0002 12Z" fill="white"></path><path d="M12.0002 20C15.3139 20 18.0002 17.3137 18.0002 14C18.0002 10.6863 15.3139 8 12.0002 8V6C16.4185 6 20.0002 9.58172 20.0002 14C20.0002 18.4183 16.4185 22 12.0002 22V20Z" fill="white"></path></svg>
      </button>
      <button class="stream-controls-actions__button" :disabled="epackSavedInBackend || loading" @click="onSaveEpackage" title="Save epackage">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V6.31242C22 5.79148 21.7967 5.29109 21.4335 4.91771L19.1835 2.60529C18.807 2.21831 18.29 2 17.7501 2H4C2.89543 2 2 2.89543 2 4ZM4 4V20H6V13C6 11.8954 6.89543 11 8 11H16C17.1046 11 18 11.8954 18 13V20H20V6.31242L17.7501 4L16 4V6C16 7.10457 15.1046 8 14 8H10C8.89543 8 8 7.10457 8 6V4H4ZM16 20V13H8V20H16ZM10 4H14V6H10V4Z" fill="#fff"></path></svg>
      </button>
      <button class="stream-controls-actions__button" :disabled="loading || !epackIdExists" @click="isSyncing = true" title="Sync epackage">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M21.66 10.37a.62.62 0 0 0 .07-.19l.75-4a1 1 0 0 0-2-.36l-.37 2a9.22 9.22 0 0 0-16.58.84 1 1 0 0 0 .55 1.3 1 1 0 0 0 1.31-.55A7.08 7.08 0 0 1 12.07 5a7.17 7.17 0 0 1 6.24 3.58l-1.65-.27a1 1 0 1 0-.32 2l4.25.71h.16a.93.93 0 0 0 .34-.06.33.33 0 0 0 .1-.06.78.78 0 0 0 .2-.11l.08-.1a1.07 1.07 0 0 0 .14-.16.58.58 0 0 0 .05-.16zM19.88 14.07a1 1 0 0 0-1.31.56A7.08 7.08 0 0 1 11.93 19a7.17 7.17 0 0 1-6.24-3.58l1.65.27h.16a1 1 0 0 0 .16-2L3.41 13a.91.91 0 0 0-.33 0H3a1.15 1.15 0 0 0-.32.14 1 1 0 0 0-.18.18l-.09.1a.84.84 0 0 0-.07.19.44.44 0 0 0-.07.17l-.75 4a1 1 0 0 0 .8 1.22h.18a1 1 0 0 0 1-.82l.37-2a9.22 9.22 0 0 0 16.58-.83 1 1 0 0 0-.57-1.28z" fill="#fff"></path></svg>
      </button>
      <copy-between-sises>
        <template #button>
          <button class="stream-controls-actions__button stream-controls-actions__button--copy-p" :disabled="loading || !epackIdExists" title="Copy page from another epackage">
            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'">
 <g>
  <path fill-rule="evenodd" clip-rule="evenodd" d="m17.7431,2c0.2796,0 0.5465,0.11705 0.7358,0.32276l3.2569,3.53832c0.1699,0.1846 0.2642,0.42634 0.2642,0.67724l0,10.46168c0,0.5523 -0.4477,1 -1,1l-5,0l0,-2l4,0l0,-8l-3,0c-1.1046,0 -2,-0.89543 -2,-2l0,-2l-3,0l0,1l-2,0l0,-2c0,-0.55228 0.4477,-1 1,-1l6.7431,0zm-0.4386,2l-0.3045,0l0,2l2.1454,0l-1.8409,-2z" fill="#8D9CA8" id="svg_1"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="m10.4789,6.32276c-0.1893,-0.20571 -0.4562,-0.32276 -0.73576,-0.32276l-6.74314,0c-0.55229,0 -1,0.44772 -1,1l0,14c0,0.5523 0.44772,1 1,1l10,0c0.5523,0 1,-0.4477 1,-1l0,-10.4617c0,-0.2509 -0.0943,-0.4926 -0.2642,-0.67722l-3.2569,-3.53832zm-6.4789,13.67724l8,0l0,-8l-3,0c-1.10457,0 -2,-0.8954 -2,-2l0,-2l-3,0l0,12zm5.30447,-12l1.84093,2l-2.1454,0l0,-2l0.30447,0z" fill="#8d9ca8" id="svg_2"/>
  <g stroke="null">
   <path stroke="null" fill="#8d9ca8" d="m8.46314,13.10314l-2.05551,0c-0.00814,0 -0.0152,0.00326 -0.0228,0.00434l-0.35127,0c-0.06732,0 -0.12161,0.05429 -0.12161,0.12161l0,5.48189c0,0.06732 0.05429,0.12161 0.12161,0.12161l1.189,0c0.06732,0 0.12161,-0.05429 0.12161,-0.12161l0,-1.7417l1.11896,0c1.07662,0 1.95235,-0.86705 1.95235,-1.93281c0.00054,-1.06576 -0.87573,-1.93335 -1.95235,-1.93335zm-0.09338,2.72656c-0.019,0.00163 -0.038,0.00326 -0.05755,0.00326l-0.9474,0c-0.00271,0 -0.00489,-0.00217 -0.0076,-0.00326a0.02785,0.02785 0 0 1 -0.01303,-0.00543a0.03133,0.03133 0 0 1 -0.0114,-0.02335l0,-1.52941c0,-0.00977 0.00489,-0.01737 0.0114,-0.02335c0.00326,-0.00326 0.0076,-0.0038 0.01194,-0.00489c0.00326,-0.00109 0.00489,-0.00326 0.00814,-0.00326l0.9474,0c0.02172,0 0.04343,0.00163 0.06461,0.00326c0.39362,0.0342 0.70417,0.37679 0.70417,0.79321c0.00054,0.41859 -0.31327,0.76281 -0.71069,0.79321z"/>
  </g>
 </g>
</svg>
          </button>
        </template>
      </copy-between-sises>
      <a
        class="stream-controls-actions__button"
        :class="{'stream-controls-actions__button--disabled': loading || !epackIdExists}"
        :href="getPreviewLink({
          activeTemplate, activeLocale, productName, epackType: typeKey, epackId: $route.params.id, page: activePage
        })"
        target="_blank"
        title="Preview"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#fff" d="M21.8661 11.5043C21.2263 10.3943 17.7077 4.82427 11.7301 5.00427C6.2023 5.14427 3.00358 10.0043 2.13392 11.5043C2.04619 11.6563 2 11.8287 2 12.0043C2 12.1798 2.04619 12.3522 2.13392 12.5043C2.76367 13.5943 6.13233 19.0043 12.02 19.0043H12.2699C17.7977 18.8643 21.0064 14.0043 21.8661 12.5043C21.9538 12.3522 22 12.1798 22 12.0043C22 11.8287 21.9538 11.6563 21.8661 11.5043ZM12.2199 17.0043C7.91163 17.1043 5.10274 13.4143 4.22309 12.0043C5.22269 10.3943 7.83166 7.10427 11.8301 7.00427C16.1184 6.89427 18.9372 10.5943 19.8269 12.0043C18.7973 13.6143 16.2183 16.9043 12.2199 17.0043Z"></path><path fill="#fff" d="M11.9998 8.50427C11.3079 8.50427 10.6315 8.70954 10.0561 9.09413C9.48077 9.47871 9.03234 10.0253 8.76754 10.6649C8.50274 11.3044 8.43345 12.0082 8.56845 12.6871C8.70344 13.366 9.03665 13.9897 9.52594 14.4791C10.0152 14.9686 10.6386 15.302 11.3173 15.437C11.996 15.5721 12.6994 15.5028 13.3387 15.2379C13.978 14.9729 14.5244 14.5243 14.9088 13.9488C15.2933 13.3732 15.4984 12.6965 15.4984 12.0043C15.4984 11.076 15.1298 10.1858 14.4737 9.5294C13.8176 8.87302 12.9277 8.50427 11.9998 8.50427ZM11.9998 13.5043C11.7033 13.5043 11.4134 13.4163 11.1668 13.2515C10.9202 13.0867 10.728 12.8524 10.6146 12.5783C10.5011 12.3042 10.4714 12.0026 10.5292 11.7116C10.5871 11.4207 10.7299 11.1534 10.9396 10.9436C11.1493 10.7338 11.4165 10.591 11.7073 10.5331C11.9982 10.4752 12.2996 10.5049 12.5736 10.6185C12.8476 10.732 13.0818 10.9242 13.2465 11.1709C13.4113 11.4176 13.4992 11.7076 13.4992 12.0043C13.4992 12.4021 13.3413 12.7836 13.0601 13.0649C12.7789 13.3462 12.3975 13.5043 11.9998 13.5043Z"></path></svg>
      </a>
      <button class="stream-controls-actions__button" :disabled="loading || !epackIdExists" @click="onDownloadEpackage" title="Download epackage">
        <svg data-v-3821ec04="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 16V19H5V16H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V16H19ZM17 10L15.59 8.59L13 11.17V3H11V11.17L8.41 8.59L7 10L12 15L17 10Z" fill="#fff"></path></svg>
      </button>
      <button class="stream-controls-actions__button" :disabled="loading || !epackIdExists" @click="onPublishEpackage" title="Publish epackage">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.6125 10.0724C15.8314 10.8534 14.5651 10.8534 13.784 10.0724C13.003 9.29132 13.003 8.02499 13.784 7.24395C14.5651 6.4629 15.8314 6.4629 16.6125 7.24395C17.3935 8.02499 17.3935 9.29132 16.6125 10.0724Z" fill="#fff"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M20.8656 2.00168C21.4098 2.00733 21.8496 2.44711 21.8552 2.99129C21.8912 6.47812 21.2437 9.4083 19.5857 11.7964C19.0126 12.6217 18.3294 13.3673 17.5325 14.0409C17.6332 14.6907 17.6412 15.3529 17.555 16.0074C17.4362 16.9097 17.1408 17.7799 16.6858 18.5681C16.2307 19.3563 15.6248 20.0472 14.9027 20.6012C14.1807 21.1553 13.3565 21.5617 12.4774 21.7973C12.2047 21.8703 11.9138 21.8247 11.6766 21.6717C11.4393 21.5187 11.2778 21.2726 11.2319 20.994L10.5263 16.7144L7.11787 13.3059L2.83831 12.6003C2.55976 12.5544 2.3136 12.3929 2.16059 12.1556C2.00759 11.9184 1.96199 11.6275 2.03506 11.3548C2.27062 10.4757 2.67704 9.65157 3.2311 8.92949C3.78517 8.20742 4.47603 7.60155 5.26425 7.14648C6.05246 6.6914 6.92259 6.39603 7.82496 6.27723C8.4926 6.18934 9.16821 6.19937 9.83059 6.30595C10.5002 5.51674 11.2409 4.83942 12.0601 4.27073C14.4483 2.61284 17.3786 1.96547 20.8656 2.00168ZM8.46837 8.22486C7.92684 9.13297 7.44446 10.1444 7.01472 11.2619L4.37945 10.8274C4.50638 10.5895 4.6529 10.3619 4.81781 10.147C5.21199 9.63332 5.70349 9.20228 6.26425 8.87853C6.825 8.55477 7.44404 8.34464 8.08601 8.26012C8.21315 8.24338 8.34071 8.23164 8.46837 8.22486ZM12.5755 16.8488L13.0048 19.4529C13.2427 19.3259 13.4703 19.1794 13.6852 19.0145C14.1989 18.6203 14.63 18.1288 14.9537 17.5681C15.2775 17.0073 15.4876 16.3883 15.5721 15.7463C15.5871 15.6323 15.5981 15.518 15.6051 15.4036C14.6987 15.9418 13.6897 16.4214 12.5755 16.8488ZM8.80956 12.1691L11.6871 15.0467C14.6928 13.9214 16.682 12.4717 17.9428 10.6558C19.143 8.92714 19.7529 6.76607 19.8444 4.01236C17.0906 4.10372 14.9293 4.71358 13.2006 5.91365C11.3846 7.17432 9.93487 9.16352 8.80956 12.1691Z" fill="#fff"></path><path d="M3.27204 20.7738C3.45961 20.9613 3.71403 21.0667 3.97929 21.0666L4.05238 21.0666C5.04701 21.0667 6.24884 21.0667 7.25579 20.6885C7.80203 20.4834 8.3205 20.1594 8.73775 19.653C9.1532 19.1488 9.42268 18.519 9.55912 17.7711C9.65824 17.2278 9.29815 16.707 8.75483 16.6079C8.21151 16.5087 7.69071 16.8688 7.5916 17.4122C7.50343 17.8955 7.35121 18.1906 7.19417 18.3812C7.03893 18.5697 6.83412 18.7105 6.55259 18.8162C6.13439 18.9733 5.62031 19.0322 4.99161 19.054C5.01341 18.4253 5.07234 17.9113 5.22941 17.4931C5.33515 17.2116 5.47599 17.0068 5.66443 16.8516C5.85506 16.6945 6.15027 16.5423 6.63359 16.4542C7.17691 16.355 7.53701 15.8342 7.43789 15.2909C7.33877 14.7476 6.81798 14.3875 6.27466 14.4866C5.52678 14.6231 4.89703 14.8925 4.39277 15.3079C3.88632 15.7251 3.56234 16.2436 3.35715 16.7898C2.97878 17.7971 2.97895 18.9993 2.9791 19.9943L2.9791 20.0665C2.97908 20.3318 3.08446 20.5862 3.27204 20.7738Z" fill="#fff"></path></svg>
      </button>
    </div>

    <sync-modal :is-open="isSyncing" @close="isSyncing = false" @sync="onSync" />
  </control-item>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";
import {showToastError, showToastSuccess} from "@/services/Helpers/HelperToast";
import openPreview from "@/mixins/openPreview"
import SyncModal from "@/containers/Constructor/containers/Controls/containers/Actions/components/SyncModal";
import ControlItem from "../../components/ControlItem";
import CopyBetweenSises from "@/components/constructor2/CopyBetweenSises";
import {AVAILABLE_EPACK_TYPES} from "@/store/modules/constructor2/consts";

export default {
  name: "Actions",

  components: {
    CopyBetweenSises,
    SyncModal,
    ControlItem
  },

  mixins: [openPreview],

  data () {
    return {
      isSyncing: false
    }
  },

  computed: {
    ...mapState({
      epackSavedInBackend: state => state.constructor2.epackSavedInBackend,
      epackData: state => state.constructor2.epackData,
      activeLocale: state => state.constructor2.activeLocale,
      activeTemplate: state => state.constructor2.activeTemplate,
      activePage: state => state.constructor2.activePage,
      loading: state => state.constructor2.loading,
    }),
    ...mapGetters({
      historyRedoAvailable: "constructor2/historyRedoAvailable",
      historyUndoAvailable: "constructor2/historyUndoAvailable",
    }),

    mappingId () {
      return this.epackData.manifest.productData.mappingId
    },

    productName() {
      return this.epackData.manifest.productData.productName
    },

    brandName() {
      return this.epackData.manifest.productData.brandName
    },

    epackIdExists () {
      return this.$route.params.id !== 'untitled'
    },

    ean() {
      return this.epackData.manifest.productData.EAN
    },

    mpn() {
      return this.epackData.manifest.productData.MPN
    },

    type() {
      return AVAILABLE_EPACK_TYPES[this.epackData.type] || AVAILABLE_EPACK_TYPES.sis
    },

    typeKey() {
      return this.type?.key
    }
  },

  methods: {
    ...mapActions({
      saveEpackage: 'constructor2/saveEpackage',
      downloadEpackage: 'constructor2/downloadEpackage',
      publishEpackage: 'constructor2/publishEpackage',
      syncComponents: 'constructor2/syncComponents',
    }),
    ...mapMutations({
      redoHistory: 'constructor2/redoHistory',
      undoHistory: 'constructor2/undoHistory',
      set: 'constructor2/set',
    }),

    async onSaveEpackage() {
      if (!this.loading) {
        this.set({ stateProp: 'loading', value: true })
        let newId
        if (this.typeKey === AVAILABLE_EPACK_TYPES.sis.key && !this.mappingId?.trim()) {
          showToastError("Mapping ID cannot be empty in Epack Data", this.$toast);
          this.set({ stateProp: 'loading', value: false })
          return
        }
        if (this.typeKey === AVAILABLE_EPACK_TYPES.minisite.key) {
          if (!this.mpn?.trim()) {
            showToastError("MPN cannot be empty in Epack Data", this.$toast);
            this.set({ stateProp: 'loading', value: false })
            return
          }
          if (!this.ean?.trim()) {
            showToastError("EAN cannot be empty in Epack Data", this.$toast);
            this.set({ stateProp: 'loading', value: false })
            return
          }
        }
        if (!this.productName?.trim()) {
          showToastError("Name cannot be empty in Epack Data", this.$toast);
          this.set({ stateProp: 'loading', value: false })
          return
        }
        if (!this.brandName?.trim()) {
          showToastError("Brand cannot be empty in Epack Data", this.$toast);
          this.set({ stateProp: 'loading', value: false })
          return
        }
        await this.saveEpackage(this.$route.params.id === 'untitled' ? undefined : this.$route.params.id)
          .then(id => {
            newId = id
            showToastSuccess("The epackage was successfully saved", this.$toast)
            if (this.$route.params.id === 'untitled') {
              if (newId) {
                this.$router.push(`/panel/builder-pro/${newId}`)
              } else {
                showToastError("Something went wrong", this.$toast);
              }
            }
          })
          .catch(() => {
            showToastError("Something went wrong", this.$toast);
          })
        this.set({ stateProp: 'loading', value: false })
      }
    },

    async onDownloadEpackage() {
      if (!this.loading) {
        this.set({ stateProp: 'loading', value: true })
        await this.downloadEpackage(this.$route.params.id)
          .catch(e => {
            console.error(e)
            showToastError(
              "Something wrong. <br/> Please try later",
              this.$toast
            );
          })
        this.set({ stateProp: 'loading', value: false })
      }
    },

    async onPublishEpackage() {
      if (!this.loading) {
        this.set({ stateProp: 'loading', value: true })
        await this.publishEpackage(this.$route.params.id)
          .then(() => {
            showToastSuccess("The epackage was successfully published", this.$toast)
          })
          .catch(e => {
            console.error(e)
            showToastError(
              "Something wrong. <br/> Please try later",
              this.$toast
            );
          })
        this.set({ stateProp: 'loading', value: false })
      }
    },

    async onSync (syncProps) {
      this.set({ stateProp: 'loading', value: true })
      await this.syncComponents(syncProps).catch(() => {})
      this.set({ stateProp: 'loading', value: false })
    }
  }
}
</script>

<style lang="scss" src="./index.scss"></style>
